import './productivity';
import './productivity.scss';
import './img/increase.png';


// WEBPACK FOOTER //
// ./resources/views/partials/home/productivity/productivity.js